import invTypeDetailDialog from './view/invTypeDetail.html'

class statisticsTaxRateDetailCtrl {
    constructor($scope, $uibModal, httpRequest, treeSelectService) {
        httpRequest.get_dictByTypeArr(['inv_type']).then((res) => {
            $scope.dictData = $.extend({}, res.data.value)
        })
        const invObj = JSON.parse(localStorage.getItem('taxStatisticsDetail')) || {}
        $scope.invObj = invObj
        $scope.param = {
            pageNum: 0,
            pageSize: 10,
            param: {
                invType: invObj.invType,
                invoiceDateMax: invObj.invoiceDateMax,
                invoiceDateMin: invObj.invoiceDateMin,
                isRed: invObj.isRed,
                ukeyIdList: [],
                orgIdList: [invObj.invoiceOrgId],
                // accessToken: $scope.pageState.idToken,
            },
        }
        $scope.taxRateThList = []
        $scope.taxRateSuffixArr = []
        httpRequest.get_getEffectiveTaxRate().then((res) => {
            const {
                value
            } = res.data
            $scope.taxRateThList = value.reduce((total, item) => {
                total.push(item.taxRatePercent === '0%' ? '其他' : item.taxRatePercent)
                return total
            }, [])
            $scope.taxRateSuffixArr = value.reduce((total, item) => {
                total.push(item.taxRateSuffix)
                return total
            }, [])
        })
        $scope.queryUkeyConfig = {
            queryName: 'ukeyName',
            queryKey: 'ukeyId',
            queryType: 'Flater',
            parentIdName: 'parentUkeyId',
            multiple: true,
            parentId: 0,
            defaultSelect: [],
        }
        $scope.reset = function () {
            $scope.queryUkeyConfig.defaultSelect = []
        }
        $scope.ukeySelectChange = function ukeySelectChange(v) {
            const ukeySelectArr = v
            const ukeySelectL = ukeySelectArr.length
            if (ukeySelectL > 0) {
                $scope.param.param.ukeyIdList = ukeySelectArr.map((item) => item.ukeyId)
            } else {
                $scope.param.param.ukeyIdList = []
            }
        }


        httpRequest.post_qryUkeyListOfOrgIds($scope.param.param.orgIdList).then((res) => {
            $scope.ukeyList = treeSelectService(res.data.value, 'ukeyId', 'ukeyName')
        })
        // 导出
        $scope.exportInvoic = function exportInvoic() {
            httpRequest.get_exportInvoiceTaxUkeyToXLS($.extend({
                accessToken: localStorage.id_token
            }, $scope.param.param))
        }

        function countResult(list) {
            let preRow = list.shift()
            const counts = {}
            // 开票点下月份数
            counts[preRow.ukeyId] = 1
            // 月份下发票种类数
            counts[`${preRow.ukeyId}${preRow.invoiceMonth}`] = 1
            do {
                const listItem = list.shift()
                if (listItem.ukeyId === preRow.ukeyId) {
                    if (listItem.invoiceMonth !== preRow.invoiceMonth) {
                        // month + 1
                        counts[listItem.ukeyId] += 1
                        // 该月份下发票种类数初始化 1
                        counts[`${listItem.ukeyId}${listItem.invoiceMonth}`] = 1
                    } else if (listItem.invType !== preRow.invType) {
                        counts[`${listItem.ukeyId}${listItem.invoiceMonth}`] += 1
                    }
                } else {
                    // 开票点下月份数
                    counts[listItem.ukeyId] = 1
                    // 月份下发票种类数
                    counts[`${listItem.ukeyId}${listItem.invoiceMonth}`] = 1
                }
                preRow = listItem
            } while (list.length > 0)
            return counts
        }

        function getRowsapns(list) {
            let preRow = list.shift()
            const rowspan = {}
            rowspan[preRow.ukeyId] = 1
            rowspan[`${preRow.ukeyId}${preRow.invoiceMonth}`] = 1
            while (list.length > 0) {
                const listItem = list.shift()
                if (!$scope.isShowThisRow(listItem)) {
                    continue
                }
                if (listItem.ukeyId === preRow.ukeyId) {
                    rowspan[listItem.ukeyId] += 1
                    if (listItem.invoiceMonth === preRow.invoiceMonth) {
                        rowspan[`${listItem.ukeyId}${listItem.invoiceMonth}`] += 1
                    } else {
                        rowspan[`${listItem.ukeyId}${listItem.invoiceMonth}`] = 1
                    }
                } else {
                    rowspan[listItem.ukeyId] = 1
                    rowspan[`${listItem.ukeyId}${listItem.invoiceMonth}`] = 1
                }
                preRow = listItem
            }
            return rowspan
        }
        $scope.getMonthRowspan = function getMonthRowspan(item) {
            return $scope.rowspans[`${item.ukeyId}${item.invoiceMonth}`]
        }

        $scope.getUkeyRowspan = function getUkeyRowspan(item) {
            return $scope.rowspans[item.ukeyId]
        }
        $scope.isShowThisRow = function isShowThisRow(item) {
            const monthCount = $scope.counts[item.ukeyId]
            const invTypeCount = $scope.counts[`${item.ukeyId}${item.invoiceMonth}`]

            if (item.invType === '9999999' && invTypeCount === 2) {
                return false
            }
            // 只选了一个月不显示月小计行
            if (monthCount === 2 && item.invoiceMonth === '9999999') {
                return false
            }
            return true
        }
        $scope.isShowThisUkey = function isShowThisUkey(item, index) {
            if (index === 0) {
                return true
            }
            const preRow = $scope.listData[index - 1]
            return preRow.ukeyId !== item.ukeyId
        }

        $scope.isShowThisMonth = function isShowThisMonth(item, index) {
            if (index === 0) {
                return true
            }
            const preRow = $scope.listData[index - 1]
            return preRow.ukeyId !== item.ukeyId ||
                preRow.invoiceMonth !== item.invoiceMonth
        }
        $scope.queryList = function queryList() {
            httpRequest.post_qryBiInvoiceRateQryOrgList($scope.param).then((res) => {
                $scope.listData = res.data.value.list
                if ($scope.listData.length === 0) {
                    return
                }
                $scope.counts = countResult($scope.listData.slice())
                $scope.rowspans = getRowsapns($scope.listData.slice())
            })
        }
        $scope.queryList()
        $scope.openInvTypeDetail = function openInvTypeDetail(item) {
            if (item.invoiceMonth === '9999999') {
                return
            }
            const param = {
                invType: item.invType,
                invoiceDateMax: item.invoiceMonth,
                invoiceDateMin: item.invoiceMonth,
                cancelStatus: $scope.param.param.cancelStatus,
                isRed: $scope.param.param.isRed,
                orgIdList: [item.invoiceOrgId],
                ukeyIdList: [item.ukeyId],
                // saleIdList: [item.saleId],
            }
            httpRequest.post_queryIsRedInvoiceList(param).then((res) => {
                $uibModal.open({
                    template: invTypeDetailDialog,
                    controller: ['$scope', '$uibModalInstance', (scope, uibModalInstance) => {
                        scope.result = res.data.value
                        if ($scope.param.param.isRed === '1') {
                            scope.result.splice(0, 1)
                        } else if ($scope.param.param.isRed === '0') {
                            scope.result.splice(1)
                        }
                        scope.cancel = function cancel() {
                            uibModalInstance.close('sz')
                        }
                        scope.taxRateThList = $scope.taxRateThList
                        scope.taxRateSuffixArr = $scope.taxRateSuffixArr
                    }],
                    openedClass: 'mod-modal mod-modal-hg',
                    backdrop: 'static',
                })
            })
        }
    }
}
statisticsTaxRateDetailCtrl.$inject = ['$scope', '$uibModal', 'httpRequest', 'treeSelectService']
export default statisticsTaxRateDetailCtrl


// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsTaxRate/statisticsTaxRateDetailCtrl.js